import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

import { CertificationRouteError } from './pages/CertificationRouteError';
export function certificationRoutes(): RouteObject[] {
  const errorElement = <CertificationRouteError />;
  return [
    {
      path: 'certifications',
      errorElement,
      lazy: () =>
        import('./pages/CertificationListPage').then((m) => ({
          Component: m.CertificationListPage,
        })),
      handle: {
        title: '기업 인증 안내',
        pageLabel: '기업 인증 안내',
        yearIndependent: true,
        feature: 'CERTIFICATION',
      } satisfies RouteHandle,
    },
    {
      path: 'certifications/:slug',
      errorElement,
      lazy: () =>
        import('./pages/CertificationDetailPage').then((m) => ({
          Component: m.CertificationDetailPage,
        })),
      handle: {
        title: '인증 절차 안내',
        pageLabel: '기업 인증 안내',
        yearIndependent: true,
        feature: 'CERTIFICATION',
      } satisfies RouteHandle,
    },
  ];
}
